import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterZoneSelected'
})

export class FilterZoneSelected implements PipeTransform {
    transform(items: any[]): any {

        return items.filter(item => item.selected)
        
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/filter-zone.pipe.ts